export const FLAG_CONFIG = {
  url: 'https://us.app.unleash-hosted.com/usii0004/api/frontend',
  appName: 'fastio-app',
  refreshInterval: 300,
  clientKey:
    __DEV__ || location.host.endsWith('fastdev1.com')
      ? 'v1:development.795609f0f2b8a6ba0d4742ef6c2a70a46f82b25c159f55242da08b9f'
      : 'v1:production.4fefd39ae63d8ddb19db216d59149a8feae9b71ce7261ae8833109d1',
};
